import React from 'react';
import { Field } from "formik";
import { makeStyles, } from "@material-ui/core";
import SelectWithLabel from "../../components/formikcomponent/SelectFieldWithLabel";
const useStyles = makeStyles(() => ({
        createUserSelect: {
                "& p": {
                        maxWidth: "200px", textOverflow: "ellipsis",
                        display: "inline-block", overflow: "hidden", whiteSpace: "nowrap !important",
                }
        }
}));
const Targetaction = (props) => {
        const classes = useStyles();
        return (
                <Field
                        name={"targetactionid"}
                        options={props.targetactionoptions}
                        placeholder="Target Action ID "
                        component={SelectWithLabel}
                        variant="filled"
                        isSearchable={false}
                        className={classes.createUserSelect + " " + "selectstyle"}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                        label="Target Action ID"
                />
        );
};


export default Targetaction;
